export default{
    applRefund:{
        btnState:{
            btn1:'Cancel',
            btn2:'Save & Submit',
            btn3:'Submit Application',
            btn4:'Received Goods',
            btn5:'Not Received',
            btn6:'Inspection Standards'
        },
        titleList:{
            title1:'Order Information',
            title2:'Refund Application',
            title3:'Specification:',
            title4:'Acceptable defect rate within',
            title5:'% is normal;',
            title6:'% requires compensation;',
            title7:'% allows discounted acceptance;',
            title8:'% requires rejection or negotiation.',
            title9:'Service Information',
            title10:'Please upload images (max 6, 5MB each, supports bmp/gif/jpg/png/jpeg) to help resolve your issue',
            title11:'Original Payment Method Refund',
            title12:'Online payments will be refunded to original account. Payment term orders will be deducted during settlement. Offline payments require buyer-seller agreement.',
            title13:'Confirmation',
            title14:'¥',
            title15:'Please keep your phone available for customer service contact!',
            title16:'¥'
        },
        plachordels:{
            pla1:'Select return reason',
            pla2:'Enter problem description (5-50 characters)',
        },
        fromtitle:{
            from1:'Order No.:',
            from2:'Order Date:',
            from3:'Subtotal:',
            from4:'Shipping Fee:',
            from5:'Order Total:',
            from18:'Amount Paid:',
            from6:'Product Name',
            from7:'Quantity',
            from8:'Goods Status:',
            from9:'Return Reason:',
            from10:'Images:',
            from11:'Problem Description:',
            from12:'Refund Method:',
            from13:'Product Refund Amount:',
            from14:'Shipping Refund Amount:',
            from15:'Total Refund Amount:',
            from16:'Customer Name:',
            from17:'Phone Number:',
            // from18:'Unit Price'
        },
       
        rulesMessage:{
            rule1:'Enter name',
            rule2:'Enter phone number',
            rule3:'Invalid phone number',
            rule4:'Select return reason',
            rule5:'Enter problem description',
            rule6:'Enter 5-50 character description',
            rule7:'Enter shipping refund amount',
            rule8:'Enter valid amount (2 decimal places)',
            rule9:'Shipping refund cannot exceed',
            rule10:'Enter product refund amount',
            rule11:'Enter valid amount (2 decimal places)',
            rule12:'Product refund cannot exceed',
            rule13:'Enter total refund amount',
            rule14:'Select resource',
            rule15:'Upload images',
            rule16:'Application submitted - awaiting review',
            rule17:'Offline payments cannot be refunded online',
        }
    }
}